// imports react
import axios from 'axios';
import React, { useEffect, useState } from 'react';

//imports libraries
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner';

import { urlAPI_Current } from '../../config';
import { Menu } from '../../components/Menu';
import styles from "../../styles/adminInvitationsManager.module.css";
import Swal from 'sweetalert2';
import { verifyAuthToken } from '../../verifyAuthToken';
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

export function AdminInvitationsManager() {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [emailContent, setEmailContent] = useState("Olá {nome}! Você recebeu um convite para o evok, acesse com o email {email}: {link}");
    const [invitations, setInvitations] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [observations, setObservations] = useState("");
    const [enterpriseId, setEnterpriseId] = useState(0);
    const [editingObservations, setEditingObservations] = useState("");
    const [editingInvitationId, setEditingInvitationId] = useState(null);
    const [enterprises, setEnterprises] = useState([]);
    const [editingInvitation, setEditingInvitation] = useState(null);

    const navigateTo = useNavigate()

    const [darkMode, setDarkMode] = useState(() => 
        window.localStorage.getItem('darkMode') === 'true'
    );

    async function getEnterprises() {
        try {
            const response = await axios.post(
                `${urlAPI_Current}/getAllEnterprises`, {}, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }
                }
            );
            if(response.data.success) {
                setEnterprises(response.data.enterprises);
            } else {
                toast.error("Erro ao buscar empresas");
            }
        } catch(err) {
            console.log(err);
            toast.error("Erro ao buscar empresas");
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseEmail = await axios.post(
                    `${urlAPI_Current}/getProfile`, {} , {
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                     }
                );
    
                if (responseEmail.data.user.codTipoUsuario == 2) {
                    getInvitations();
                } else {
                    toast.error("Você não tem acesso a essa página");
                    navigateTo("/login");
                }
            } catch (error) {
                console.error("Erro ao buscar perfil:", error);
            }
        };
    
        fetchData();
    
        window.localStorage.setItem('darkMode', darkMode);
        document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    }, [darkMode]);
    
    async function createInvitation(){
        try {
            if(email == "" || name == "" || emailContent == "" || enterpriseId <= 0){
                toast.error("Preencha todos os campos");
                return;
            } else {
                const response = await axios.post(
                    `${urlAPI_Current}/addInvitation`,
                    {
                        email: email,
                        name: name,
                        emailContent: emailContent,
                        observations: observations,
                        enterpriseId: enterpriseId
                    } , {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`,  
                            'Content-Type': 'application/json'
                        }
                        }
                )
                if(response.data.success == true){
                    setEmail("");
                    toast.success("Convite criado com sucesso!");

                    setEmail("");
                    setName("");
                    setEmailContent("Olá {nome}! Você recebeu um convite para o evok, acesse com o email {email}: {link}");
                    setObservations("");
                    setEnterpriseId(0);

                    setTimeout(() => {
                        getInvitations();
                        resendInvitations(response.data.invitationId, false);
                    }, 500);
                    console.log(response.data)
                } else {
                    toast.error("Já possui uma licença com esse email");
                    setEmail("");
                } 
            }
        } catch(err){
            console.log(err);
            toast.error("Erro ao criar licença");
        }
    }

    async function getInvitations(){
        const response = await axios.post(
            `${urlAPI_Current}/getInvitationsByCreator`, {} , {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
             }
        )
        if(response.data.success == true){
           setInvitations(response.data.invitations)
        } else {
            toast.error("Erro ao criar licença");
        }
    }

    async function resendInvitations(invitationId, needConfirmation) {
        if (!needConfirmation) {
            sendInvitationEmail(invitationId);
            return;
        }
    
        const result = await Swal.fire({
            title: 'Deseja Continuar?',
            text: "Deseja reenviar esse convite por email?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            didOpen: () => {
                const popup = Swal.getPopup();
                if (popup) {
                    popup.style.backgroundColor = darkMode ? '#212121' : '#f0f0f0';
                    const popupText = popup.querySelector('.swal2-title');
                    if (popupText) {
                        popupText.style.color = darkMode ? '#f0f0f0' : '#212121';
                    }
    
                    const popupTextContent = popup.querySelector('.swal2-html-container');
                    if (popupTextContent) {
                        popupTextContent.style.color = darkMode ? '#f0f0f0' : '#212121';
                    }
                }
            }
        });
    
        if (result.isConfirmed) {
            sendInvitationEmail(invitationId);
        }
    }

    async function sendInvitationEmail(invitationId) {
        try {
            console.log(invitationId);
            const response = await axios.post(
                `${urlAPI_Current}/resendEmailInvitation`,
                { invitationId },
                {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }
                }
            );
    
            if (response.data.success) {
                const email = response.data.emailSent;
                toast.success(`Convite enviado com sucesso para ${email}`);
                setTimeout(() => {
                    getInvitations();
                }, 500);
            } else {
                toast.error('Erro ao enviar email');
                console.log("Erro ao reenviar email");
            }
        } catch (error) {
            toast.error('Erro ao reenviar email');
            console.log("Erro ao reenviar email", error);
        }
    }

    async function deleteInvitation(invitationId){
        const result = await Swal.fire({
            title: 'Deseja Continuar?',
            text: "Deseja realmente excluir esse convite?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            didOpen: () => {
            const popup = Swal.getPopup();
            if (popup) {
                popup.style.backgroundColor = darkMode ? '#212121' : '#f0f0f0';
                const popupText = popup.querySelector('.swal2-title');
            if (popupText) {
                popupText.style.color = darkMode ? '#f0f0f0' : '#212121';
            }
    
            const popupTextContent = popup.querySelector('.swal2-html-container');
            if (popupTextContent) {
                popupTextContent.style.color = darkMode ? '#f0f0f0' : '#212121';
            }
            }
            }
        });
    
        if (result.isConfirmed) {
            try {
            const response = await axios.post(
                `${urlAPI_Current}/deleteInvitation`,
                {
                    invitationId: invitationId
                }, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                      }
                }
            );
        
            if(response.data.success){
                toast.success('Convite deletado com sucesso!');
                getInvitations();
            } else {
                toast.error('Erro ao deletar usuário');
                console.log('Erro ao deletar usuário');
            }
            } catch (error) {
            console.log("Erro ao deletar usuario");
            }
        } 
    }

    async function updateInvitation() {
        try {
            const response = await axios.post(
                `${urlAPI_Current}/updateInvitation`,
                {
                    invitationId: editingInvitation?.codConvite,
                    email: editingInvitation?.email,
                    name: editingInvitation?.nomeCliente,
                    emailContent: editingInvitation?.conteudoEmail,
                    observations: editingInvitation?.observacoes,
                    enterpriseId: editingInvitation?.codEmpresa
                },
                {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                    }
                }
            );
    
            if (response.data.success) {
                toast.success('Convite atualizado com sucesso!');
                setEditingInvitation(null);
                getInvitations();

                const modal = document.getElementById('kt_modal_edit_observations');
                const modalInstance = new window.bootstrap.Modal(modal); // Use window.bootstrap
                modalInstance.hide();
            } else {
                toast.error('Erro ao atualizar convite');
            }
        } catch (error) {
            console.error(error);
            toast.error('Erro ao atualizar convite');
        }
    }

    function openEditModal(invitationId) {
        const invitation = invitations.find(invitation => invitation.codigoConvite === invitationId);
        
        console.log(invitation);
        
        if (invitation) {
            setEditingInvitation(invitation); 
        }
    }

    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach(tooltipTriggerEl => {
            new window.bootstrap.Tooltip(tooltipTriggerEl);
        });
    }, [invitations]);

    async function downloadFinalReportPdf(codCliente, nomeCliente) {
        try {
          toast.info('Iniciando download do relatório...');
      
          const response = await axios.post(
            `${urlAPI_Current}/downloadReportPDFByAdmin`,
            {
              selectedUserId: codCliente
            },
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
              },
              responseType: 'blob'
            }
          );
      
          // Cria um link temporário para download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `relatorio-${nomeCliente}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
      
          toast.success('Relatório baixado com sucesso!');
        } catch (error) {
          console.error('Erro ao baixar o PDF:', error);
          toast.error('Relatório não encontrado. Tente novamente');
        }
      }

    async function generateFinalReportAgain(codCliente){
        const result = await Swal.fire({
            title: 'Deseja Continuar?',
            text: "Deseja realmente começar a rotina de gerar esse relatório novamente?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            didOpen: () => {
            const popup = Swal.getPopup();
            if (popup) {
                popup.style.backgroundColor = darkMode ? '#212121' : '#f0f0f0';
                const popupText = popup.querySelector('.swal2-title');
            if (popupText) {
                popupText.style.color = darkMode ? '#f0f0f0' : '#212121';
            }
    
            const popupTextContent = popup.querySelector('.swal2-html-container');
            if (popupTextContent) {
                popupTextContent.style.color = darkMode ? '#f0f0f0' : '#212121';
            }
            }
            }
        });
    
        if (result.isConfirmed) {
            toast.success('Relatório sendo gerado novamente!');
            axios.post(`${urlAPI_Current}/generateFinalReportAgain`, 
                {
                    selectedUserId: codCliente
                }, 
                {
                    headers: {
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                    }, 
                })
            .then(response => {
                if(response.data.success) {
                    console.log('Relatório gerado com sucesso');
                }
            })
            .catch(error => {
                toast.error('Erro ao gerar relatorio');
                console.error('Erro ao iniciar geração do relatório:', error);
            });
        }
    }

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
      };
    
    const filteredInvitations = invitations.filter(
    (invitation) =>
        invitation?.email?.toLowerCase().includes(searchTerm?.toLowerCase() || '')
    );

    useEffect(() => {
        verifyAuthToken(navigateTo);
        getEnterprises();
    }, []);

    return (
        <div className={styles.divAdminBi}>
            <Menu darkMode={darkMode} adminUser={true} adminPageActually="invitationsManager"/>
            <div className={styles.containerBI}>
                <div className="content d-flex flex-column flex-column-fluid" id="kt_content"  data-bs-theme={darkMode ? "dark" : "light"}>
                    <div id="kt_content_container" style={{ width: "1800px", margin: "0 auto" }}>
                        <div className="card card-flush">
                            <div className="card-header mt-6">
                                <div className="card-title">
                                    <div className="d-flex align-items-center position-relative my-1 me-5">
                                        <i className="ki-outline ki-magnifier fs-3 position-absolute ms-5"></i>
                                        <input 
                                            type="text" 
                                            data-kt-permissions-table-filter="search" 
                                            className={`form-control form-control-solid w-250px ps-13 ${styles.inputFilter}`}
                                            placeholder="Procurar por email" 
                                            defaultValue={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                </div>
                                <div className="card-toolbar">	
                                    <button type="button" className="btn btn-light-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_add_permission">
                                    <i className="ki-outline ki-plus-square fs-3"></i>Adicionar Convite</button>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0" id="kt_permissions_table">
                                    <thead>
                                        <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="min-w-100px">Empresa</th>
                                            <th className="min-w-150px">Email</th>
                                            <th className="min-w-150px">Nome</th>
                                            <th className="min-w-100px">Token</th>
                                            <th className="min-w-100px">Link</th>
                                            <th className="min-w-80px">Respondidas</th>
                                            <th className="min-w-80px">Questionario</th>
                                            <th className="min-w-125px">Tempo Pendente</th>
                                            <th className="min-w-100px">Status Email</th>
                                            <th className="min-w-80px">Envios</th>
                                            <th className="min-w-100px">Data de Envio</th>
                                            <th className="min-w-100px">Observações</th>
                                            <th className="text-end min-w-200px">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">
                                        {filteredInvitations.length > 0 ? (
                                            filteredInvitations.map((invitation, index) => (
                                                <tr key={index}>
                                                    <td>{invitation.nomeEmpresa}</td>
                                                    <td>{invitation.email}</td>
                                                    <td>{invitation.nomeCliente}</td>
                                                    <td className="min-w-100px">
                                                        {invitation.resgatado
                                                            ? <><span>Usado</span> <i className="ki-outline ki-check-circle fs-3 text-success"></i></>
                                                            : <><span>Valido</span> <i className="ki-outline ki-check-circle fs-3 text-primary"></i></>}
                                                    </td>
                                                    <td><span className={invitation.linkAcessado ? "badge badge-light-success fs-7 m-1" : "badge badge-light-danger fs-7 m-1"}>
                                                            {invitation.linkAcessado ? "Sim" : "Não"}
                                                        </span>
                                                    </td>
                                                    <td>{invitation.respondidas}</td>
                                                    <td><span className={invitation.relatorioEnviado ? "badge badge-light-success fs-7 m-1" : "badge badge-light-danger fs-7 m-1"}>
                                                            {invitation.relatorioEnviado ? "Sim" : "Não"}
                                                        </span>
                                                    </td>
                                                    <td>{invitation.resgatado ? "---": `${invitation.tempoPendente}`}</td>
                                                    <td>
                                                        {invitation.statusEmail === -1 
                                                            ? "Erro" 
                                                            : invitation.statusEmail === 0 
                                                            ? "Não enviado" 
                                                            : "Enviado"}
                                                    </td>
                                                    <td>{invitation.quantidadeEmailsEnviados}</td>
                                                    <td>
                                                        <div 
                                                            className="text-hover-primary cursor-pointer"
                                                            data-bs-toggle="tooltip" 
                                                            data-bs-placement="bottom"
                                                            data-bs-html="true"
                                                            title={
                                                                invitation.datasEnvio 
                                                                    ? invitation.datasEnvio
                                                                        .split(',')
                                                                        .map(data => new Date(data).toLocaleString('pt-BR'))
                                                                        .join('<br/>')
                                                                    : ""
                                                            }
                                                        >
                                                            {invitation.datasEnvio && 
                                                                new Date(invitation.datasEnvio.split(',')[0]).toLocaleString('pt-BR')
                                                            }
                                                            {invitation.datasEnvio && invitation.datasEnvio.split(',').length > 1 && 
                                                                ` (+${invitation.datasEnvio.split(',').length - 1})`
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div 
                                                            className="text-hover-primary cursor-pointer"
                                                            data-bs-toggle="tooltip" 
                                                            data-bs-placement="bottom"
                                                            data-bs-html="true"
                                                            title={invitation.observacoes || ""}
                                                            style={{
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: '3',
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '200px',
                                                                whiteSpace: 'pre-line'
                                                            }}
                                                        >
                                                            {invitation.observacoes || ""}
                                                        </div>
                                                    </td>
                                                    <td className="text-end">
                                                        <button className="btn btn-icon btn-active-light-primary w-30px h-30px me-2" 
                                                            onClick={() => openEditModal(invitation.codigoConvite, invitation.observacoes)}
                                                            data-bs-toggle="modal" 
                                                            data-bs-target="#kt_modal_edit_observations">
                                                             <i className={`ki-outline ki-pencil fs-3 ${styles.botaoExcluir}`}></i>
                                                        </button>
                                                        <button className="btn btn-icon btn-active-light-primary w-30px h-30px" onClick={() => resendInvitations(invitation.codigoConvite, true)}>
                                                            <i className={`ki-outline ki-send fs-3 ${styles.botaoExcluir}`}></i>
                                                        </button>
                                                        <button className="btn btn-icon btn-active-light-primary w-30px h-30px" onClick={() => deleteInvitation(invitation.codigoConvite)}>
                                                            <i className={`ki-outline ki-trash fs-3 ${styles.botaoExcluir}`}></i>
                                                        </button>
                                                        {invitation.codRelatorioFinal ? (
                                                            <button className="btn btn-icon btn-active-light-primary w-30px h-30px" onClick={() => downloadFinalReportPdf(invitation.codCliente, invitation.nomeCliente)}>
                                                                <i className={`ki-outline ki-file-down fs-3 ${styles.botaoExcluir}`}></i>
                                                            </button>
                                                        ) : (null)}
                                                        {invitation.relatorioEnviado ? (
                                                            <button className="btn btn-icon btn-active-light-primary w-30px h-30px" onClick={() => generateFinalReportAgain(invitation.codCliente)}>
                                                                <i className={`ki-outline ki-arrows-circle fs-3 ${styles.botaoExcluir}`}></i>
                                                            </button>
                                                        ) : (null)}
                                                    </td>
                                                </tr>
                                            ))
                                            ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center text-muted">
                                                    Nenhum convite encontrado.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal fade" id="kt_modal_add_permission" tabindex="-1" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered mw-650px">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h2 className="fw-bold">Adicionar Convite</h2>
                                        <div className="btn btn-icon btn-sm btn-active-icon-primary" data-kt-permissions-modal-action="close">
                                            <i className="ki-outline ki-cross fs-1" data-bs-dismiss="modal"></i>
                                        </div>
                                    </div>
                                    <div className="modal-body mx-5 mx-xl-15 my-7">
                                        <form id="kt_modal_add_permission_form" className="form w-100" onSubmit={(e) => {
                                                e.preventDefault();
                                                createInvitation();
                                            }}>
                                            <div className="fv-row mb-7">
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Email</span>
                                                    <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                </label>
                                                <input 
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite um email"
                                                    type="email" 
                                                    name="email" 
                                                    value={email} 
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required 
                                                />
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Nome</span>
                                                    <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                </label>
                                                <input 
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite um nome"
                                                    type="name" 
                                                    name="name" 
                                                    value={name} 
                                                    onChange={(e) => setName(e.target.value)} 
                                                    required
                                                />
                                                <label className="fs-6 fw-semibold form-label mt-3">Empresas</label>
                                                <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                <select 
                                                    className="form-select form-select-solid"
                                                    value={enterpriseId}
                                                    onChange={(e) => setEnterpriseId(e.target.value)}
                                                >
                                                    <option value="">Selecione uma empresa</option>
                                                    {enterprises.map((enterprise) => (
                                                        <option key={enterprise.codEmpresa} value={enterprise.codEmpresa}>
                                                            {enterprise.nome}
                                                        </option>
                                                    ))}
                                                </select>
                                                <br />
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Conteudo do Email</span>
                                                    <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                </label>
                                                <br />
                                                <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                    <i className="">Variáveis entre chaves: &#123;nome&#125; &#123;email&#125; &#123;link&#125;</i>
                                                </span>
                                                <textarea
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite o conteudo do email"
                                                    name="emailContent"
                                                    value={emailContent}
                                                    onChange={(e) => setEmailContent(e.target.value)}
                                                    rows="3"
                                                    required
                                                ></textarea>
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Observações</span>
                                                </label>
                                                <textarea
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite as observacões"
                                                    name="observations"
                                                    value={observations}
                                                    onChange={(e) => setObservations(e.target.value)}
                                                    rows="3"
                                                ></textarea>
                                            </div>
                                            <div className="text-center pt-15">
                                                <button type="reset" className="btn btn-light me-3" data-kt-permissions-modal-action="cancel" data-bs-dismiss="modal">Cancelar</button>
                                                <button type="submit" className="btn btn-primary" data-kt-permissions-modal-action="submit" data-bs-dismiss="modal">  
                                                    <span className="indicator-label">Enviar</span> 
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>	
                        <div className="modal fade" id="kt_modal_edit_observations" tabindex="-1" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered mw-650px">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h2 className="fw-bold">Atualizar convite</h2>
                                        <div className="btn btn-icon btn-sm btn-active-icon-primary" data-kt-permissions-modal-action="close">
                                            <i className="ki-outline ki-cross fs-1" data-bs-dismiss="modal"></i>
                                        </div>
                                    </div>
                                    <div className="modal-body mx-5 mx-xl-15 my-7">
                                        <form id="kt_modal_add_permission_form" className="form w-100" onSubmit={(e) => {
                                                e.preventDefault();
                                                updateInvitation();
                                            }}>
                                            <div className="fv-row mb-7">
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Email</span>
                                                    <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                </label>
                                                <input 
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite um email"
                                                    type="email" 
                                                    name="email" 
                                                    value={editingInvitation?.email || ''}
                                                    onChange={(e) => setEditingInvitation({ ...editingInvitation, email: e.target.value })}
                                                    required 
                                                />
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Nome</span>
                                                    <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                </label>
                                                <input 
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite um nome"
                                                    type="name" 
                                                    name="name" 
                                                    value={editingInvitation?.nomeCliente || ''} 
                                                    onChange={(e) => setEditingInvitation({ ...editingInvitation, nomeCliente: e.target.value })}
                                                    required
                                                />
                                                <label className="fs-6 fw-semibold form-label mt-3">Empresas</label>
                                                <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                <select 
                                                    className="form-select form-select-solid"
                                                    value={editingInvitation?.codEmpresa || ''} 
                                                    onChange={(e) => editingInvitation({ ...editingInvitation, codEmpresa: e.target.value })}
                                                >
                                                    <option value="">Selecione uma empresa</option>
                                                    {enterprises.map((enterprise) => (
                                                        <option key={enterprise.codEmpresa} value={enterprise.codEmpresa}>
                                                            {enterprise.nome}
                                                        </option>
                                                    ))}
                                                </select>
                                                <br />
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Conteudo do Email</span>
                                                    <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                        <i className="ki-outline ki-information fs-7"></i>
                                                    </span>
                                                </label>
                                                <br />
                                                <span className="ms-2" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Permission names is required to be unique.">
                                                    <i className="">Variáveis entre chaves: &#123;nome&#125; &#123;email&#125; &#123;link&#125;</i>
                                                </span>
                                                <textarea
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite o conteudo do email"
                                                    name="emailContent"
                                                    value={editingInvitation?.conteudoEmail || ''} 
                                                    onChange={(e) => setEditingInvitation({ ...editingInvitation, conteudoEmail: e.target.value })}
                                                    rows="3"
                                                    required
                                                ></textarea>
                                                <label className="fs-6 fw-semibold form-label mb-2">
                                                    <span className={styles.labelEmail}>Observações</span>
                                                </label>
                                                <textarea
                                                    className={`form-control form-control-solid ${styles.inputFilter}`}
                                                    placeholder="Digite as observacões"
                                                    name="observations"
                                                    value={editingInvitation?.observacoes || ''} 
                                                    onChange={(e) => setEditingInvitation({ ...editingInvitation, observacoes: e.target.value })}
                                                    rows="3"
                                                ></textarea>
                                            </div>
                                            <div className="text-center pt-15">
                                                <button type="reset" className="btn btn-light me-3" data-kt-permissions-modal-action="cancel" data-bs-dismiss="modal">Cancelar</button>
                                                
                                                <button type="submit" className="btn btn-primary" data-kt-permissions-modal-action="submit" data-bs-dismiss="modal">  
                                                    <span className="indicator-label">Editar</span> 
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
